"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = identity;

function identity(x) {
  return x;
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/victory-vendor/lib-vendor/d3-array/src/identity.js
// module id = 499
// module chunks = 249